import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withLocalize } from "react-localize-redux";

import Nav from '../../_layout/nav/Nav';

import AdminsRouter from './AdminsRouter';
import ClientsRouter from './ClientsRouter';
import CampaignsRouter from './CampaignsRouter';
import UsersRouter from './UsersRouter';


class Home extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount() {
    let account = JSON.parse(localStorage.getItem('account') || "{}")
    if (!(account && account.token)) {
      window.account = {}
      this.props.history.push('/login/admin');
    } else {
      window.account = account
    }
  }

  public render() {
    return (
      <div id="router-root">
        <ToastContainer position="top-left" />
        <Nav history={this.props.history}/>
        <div className="innerWindow">
          <Switch>
            <Route path={`/campaigns`} component={CampaignsRouter} />
            <Route path={`/clients`} component={ClientsRouter} />
            <Route path={`/admins`} component={AdminsRouter} />
            <Route path={`/users`} component={UsersRouter} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withLocalize(Home);



// WEBPACK FOOTER //
// ./src/pages/home/Home.tsx